import { ORIGIN_VIEWPORT } from 'hellospa/components/signature-request';

const dragStart = new WeakMap();

export function moveInitialOffset(zoomContext, item, initialOffset, currentOffset) {
  // Store the page address on the first pass
  if (!dragStart.has(item)) {
    const originalAddress = zoomContext.fromScreenCoords({
      // fromScreenCoords will change the pageIndex to whatever it needs to be
      pageIndex: 0,
      x: initialOffset.x,
      y: initialOffset.y,
      width: 0,
      height: 0,
    }, ORIGIN_VIEWPORT);

    dragStart.set(item, originalAddress);
  }
  const originalAddress = dragStart.get(item);

  const iOffset = zoomContext.toScreenCoords(originalAddress, ORIGIN_VIEWPORT);
  const moveDistance = {
    x: currentOffset.x - iOffset.x,
    y: currentOffset.y - iOffset.y,
  };

  return {
    initialOffset: iOffset,
    moveDistance,
  };
}


export default ({
  editorContext,
  zoomContext,
  currentOffset,
  initialOffset: iOffset,
  item,
  fields,
}) => {

  const {
    initialOffset, moveDistance,
  } = moveInitialOffset(zoomContext, item, iOffset, currentOffset);


  let radioShift = { x: 0, y: 0 };
  const movedFields = fields.map((fieldData, index) => {
    let fieldDataOverride = {};

    // If this is a new component, always drag from the center.
    if (fieldData.id == null) {
      const { x, y, pageIndex } = zoomContext.fromScreenCoords({
        ...fieldData,
        ...initialOffset,
      }, ORIGIN_VIEWPORT);

      // Push the top-left corner of the field so that initialOffset is in the
      // center
      fieldDataOverride = {
        pageIndex,
        x: x - (fieldData.width / 2),
        y: y - (fieldData.height / 2),
      };

      // Radio buttons are extra special because they can only be created in
      // pairs.
      if (fieldData.type === 'radiobutton') {
        if (index === 0) {
          // Record the distance the first radio button was moved
          radioShift = {
            x: fieldData.x - fieldDataOverride.x,
            y: fieldData.y - fieldDataOverride.y,
          };
        } else {
          // and instead of centering, shift the other components by the same amount
          fieldDataOverride.x = fieldData.x - radioShift.x;
          fieldDataOverride.y = fieldData.y - radioShift.y;
        }
      }

    }

    const position = zoomContext.toScreenCoords({
      ...fieldData,
      ...fieldDataOverride,
    }, ORIGIN_VIEWPORT);

    const address = zoomContext.fromScreenCoords({
      ...fieldData,
      ...position,
      x: position.x + moveDistance.x,
      y: position.y + moveDistance.y,
    }, ORIGIN_VIEWPORT);

    return {
      ...fieldData,
      ...address,
    };
  });

  const valid = movedFields.reduce(
    (v, field) => v && editorContext.isValidAddress(
      field,
      movedFields.filter((f) => f !== field),
    ),
    true,
  );


  return { valid, fields: movedFields };
};
